import iconClose from "../../../../images/contents/map/pointinfo/close.svg";
import iconCloseActive from "../../../../images/contents/map/pointinfo/close_active.svg";
import iconCloseHover from "../../../../images/contents/map/pointinfo/close_hover.svg";
import iconDetail from "../../../../images/contents/map/pointinfo/detail.svg";
import iconDetailActive from "../../../../images/contents/map/pointinfo/detail_active.svg";
import iconDetailHover from "../../../../images/contents/map/pointinfo/detail_hover.svg";
import iconOpen from "../../../../images/contents/map/pointinfo/open.svg";
import iconOpenActive from "../../../../images/contents/map/pointinfo/open_active.svg";
import iconOpenHover from "../../../../images/contents/map/pointinfo/open_hover.svg";
import iconSimple from "../../../../images/contents/map/pointinfo/simple.svg";
import iconSimpleActive from "../../../../images/contents/map/pointinfo/simple_active.svg";
import iconSimpleHover from "../../../../images/contents/map/pointinfo/simple_hover.svg";

export const configAmedasDh = {
  "Controller": {
    "Name": "EXPO_ObservationDBExt",
  },
  "Source": {
    "master": {
      "Type": "JSON",
      "url": "%expo_observation_url%/AMEDAS/master",
      "retain": true
    },
    "time": {
      "Type": "JSON",
      "url": "%expo_observation_url%/AMEDAS/time?valid_time=%validtime%",
      "cache": true,
      "retain": true
    },
    "timelist": {
      "Type": "JSON",
      "url": "%expo_observation_url%/AMEDAS/validtime",
      "cache_busting": true,
      "cache": false,
      "retain": true,
      "update_interval": 60
    },
    "info": {
      "Type": "GeoJSON",
      "url": "%expo_observation_url%/AMEDAS/info",
      "retain": true
    },
    "data": {
      "Type": "Derived",
      "retain": true
    }
  }
};

const _baseConfigLayer = {
  "Name": "PointInfoSample",
  "Renderer": "PointInfoExt",
  "Attributes": {
    "key": "LCLID",
    "padding_button": 6,
    "open_button": iconOpen,
    "open_button_hover": iconOpenHover,
    "open_button_active": iconOpenActive,
    "close_button": iconClose,
    "close_button_hover": iconCloseHover,
    "close_button_active": iconCloseActive,
    "simple_button": iconSimple,
    "simple_button_hover": iconSimpleHover,
    "simple_button_active": iconSimpleActive,
    "detail_button": iconDetail,
    "detail_button_hover": iconDetailHover,
    "detail_button_active": iconDetailActive,
    "point": {
      "_mask_size": 6,
      "size": 10,
      "sensor_size": 14,
      "color": "#A9F5F2",
      "line_color": "rgba(0,0,0,0.2)",
      "line_width": 1
    },
    "label": {
      "prioritize_zoom": 7,
      "_prioritize_max_point": 200,
      "prioritize_max_point": 1,
      "position": [
        [40, 112.5],
        [40, 135],
        [40, 157.5],
        [40, 180],
        [40, 202.5],
        [40, 225],
        [40, 247.5],
        [40, 270],
        [40, 292.5],
        [40, 315],
        [40, 337.5],
        [40, 360],
        [40, 22.5],
        [40, 45],
        [40, 67.5],
        [40, 90]
      ],
      "font_size": 12,
      "margin": 80,
      "point_color": "#00bfff",
      "text_color": "#fff",
      "padding": 4,
      "padding_top": 12,
      "padding_bottom": 12,
      "padding_left": 12,
      "padding_right": 12,
      "round_corner": 6,
      "line_color": "rgba(0,0,0,0.9)",
      "line_width": 1.5,
      "edge_color": "#fff",
      "edge_width": 2,
      "fill_color": "rgba(0,0,0,0.7)",
      "min_width": 200,
      "text_lines": [
        "%LNAME%",
        "%label.AIRTMP%",
        "%label.WNDSPD%",
        "%label.PRCRIN_1HOUR%",
        "%label.SUNDUR_1HOUR%",
        "%valid_time%"
      ]
    },
    "tooltip": {
      "font_size": 12,
      "text_color": "#fff",
      "line_color": "#fff",
      "line_width": 0.5,
      "fill_color": "rgba(0,0,0,0.9)",
      "width": 200,
      "padding": 4,
      "padding_top": 12,
      "padding_bottom": 12,
      "padding_left": 12,
      "padding_right": 12,
      "round_corner": 6,
      "text_lines": [
        "%LNAME%",
        "%label.AIRTMP%",
        "%label.PRCRIN_1HOUR%",
        "%label.SUNDUR_1HOUR%",
        "%label.SNWDPT%",
        "%label.WNDSPD%",
        "%label.WNDDIR%",
        "%label.GUSTS%",
        "%label.GUSTD%",
        "%valid_time%"
      ]
    },
    "popup": {
      "font_size": 12,
      "point_color": "#0000ff",
      "text_color": "#222",
      "line_color": "#222",
      "line_width": 2,
      "fill_color": "rgba(250,250,250,0.9)",
      "width": 300,
      "padding": 4,
      "padding_top": 12,
      "padding_bottom": 12,
      "padding_left": 12,
      "padding_right": 52,
      "round_corner": 6,
      "popup_link": true,//同一LCLIDのポップアップ連携
      "text_lines": [
        "%LNAME%",
        "%label.AIRTMP%",
        "%label.GUSTS%",
        "%label.PRCRIN_1HOUR%",
        "%label.SUNDUR_1HOUR%",
        "%label.SNWDPT%",
        "%valid_time%"
      ],
      "extended_text_lines": [
        "AMEDAS",
        "%LNAME% / %ADDRSS%",
        "LCLID: %LCLID%",
        "-----",
        "%label.AIRTMP%",
        "%label.AIRTMP_10MIN_MAX%",
        "%label.AIRTMP_10MIN_MIN%",
        "",
        "%label.PRCRIN_10MIN%",
        "%label.PRCRIN_1HOUR%",
        "%label.PRCRIN_3HOUR%",
        "%label.PRCRIN_6HOUR%",
        "%label.PRCRIN_12HOUR%",
        "%label.PRCRIN_24HOUR%",
        "",
        "%label.RHUM%",
        "%label.RHUM_10MIN_MIN%",
        "",
        "%label.ARPRSS%",
        "%label.SSPRSS%",
        "",
        "%label.SUNDUR_1HOUR%",
        "",
        "%label.WNDSPD%",
        "%label.WNDDIR%",
        "%label.GUSTS%",
        "%label.GUSTD%",
        "",
        "%label.SNWDPT%",
        "%label.SNWFLL_01HOUR%",
        "%label.SNWFLL_03HOUR%",
        "%label.SNWFLL_06HOUR%",
        "%label.SNWFLL_12HOUR%",
        "%label.SNWFLL_24HOUR%",
        "",
        "%valid_time%"
      ]
    },
    "custom": {
      "valid_time": {
        "en": "MM/DD HH:mm z",
        "ja": "MM月DD日 HH時mm分 z"
      }
    },
    "selection_label": {
      "key": "LNAME",
      "position": [10, 4],
      "font_size": 12,
      "text_color": "#fff",
      "text_edge_color": "#000"
    }
  }
};

const airTmpColorMap = {
  "property": "AIRTMP",
  "map": [
    {"ge": 35, "value": "rgb(180, 0, 104)"},
    {"ge": 30, "value": "rgb(255, 40, 0)"},
    {"ge": 25, "value": "rgb(255, 153, 0)"},
    {"ge": 20, "value": "rgb(250, 245, 0)"},
    {"ge": 15, "value": "rgb(255, 255, 150)"},
    {"ge": 10, "value": "rgb(255, 255, 240)"},
    {"ge": 5,  "value": "rgb(185, 235, 255)"},
    {"ge": 0,  "value": "rgb(0, 150, 255)"},
    {"ge": -5, "value": "rgb(0, 65, 255)"},
    {"lt": -1000, "value": "rgba(0,0,0,0.1)"},
    {"lt": -5, "value": "rgb(0, 32, 128)"},
    {"value": "rgb(0,0,0,0.1)"}
  ]
};

const sunshineColorMap = {
  "property": "SUNDUR_1HOUR",
  "map": [
    {"ge": 60, "value": "rgb(180, 0, 104)"},
    {"ge": 48,  "value": "rgb(255, 40, 0)"},
    {"ge": 36,  "value": "rgb(255, 153, 0)"},
    {"ge": 24,  "value": "rgb(250, 245, 0)"},
    {"ge": 12,  "value": "rgb(185, 235, 255)"},
    {"lt": -1000, "value": "rgba(0,0,0,0.1)"},
    {"lt": 12,  "value": "rgba(0, 65, 255)"},
    {"value": "rgb(0,0,0,0.1)"}
  ]
};

const precipitationColorMap = {
  "property": "PRCRIN_1HOUR",
  "map": [
    {"ge": 80, "value": "rgb(180, 0, 104)"},
    {"ge": 50, "value": "rgb(255, 40, 0)"},
    {"ge": 30, "value": "rgb(255, 153, 0)"},
    {"ge": 20, "value": "rgb(250, 245, 0)"},
    {"ge": 10, "value": "rgb(0, 65, 255)"},
    {"ge": 5,  "value": "rgb(33, 140, 255)"},
    {"ge": 1,  "value": "rgb(160, 210, 255)"},
    {"lt": -1000, "value": "rgba(0,0,0,0.1)"},
    {"lt": 1,  "value": "rgba(242, 242, 255)"},
    {"value": "rgb(0,0,0,0.1)"}
  ]
};

const snowDepthColorMap = {
  "property": "SNWDPT",
  "map": [
    {"ge": 200, "value": "rgb(180, 0, 104)"},
    {"ge": 150, "value": "rgb(255, 40, 0)"},
    {"ge": 100, "value": "rgb(255, 153, 0)"},
    {"ge": 50,  "value": "rgb(250, 245, 0)"},
    {"ge": 20,  "value": "rgb(0, 65, 255)"},
    {"ge": 5,   "value": "rgb(33, 140, 255)"},
    {"ge": 1,   "value": "rgb(160, 210, 255)"},
    {"lt": -1000, "value": "rgba(0,0,0,0.1)"},
    {"lt": 1,   "value": "rgba(242, 242, 255)"},
    {"value": "rgb(0,0,0,0.1)"}
  ]
};

export const configAmedasAirTempLayer = {
  ..._baseConfigLayer,
  "Attributes": {
    ..._baseConfigLayer.Attributes,
    "point": {
      ..._baseConfigLayer.Attributes.point,
      "color": airTmpColorMap
    },
    "label": {
      ..._baseConfigLayer.Attributes.label,
      "point_color": airTmpColorMap,
      "edge_color": airTmpColorMap
    },
    "popup": {
      ..._baseConfigLayer.Attributes.popup,
      "point_color": airTmpColorMap,
      "line_color": airTmpColorMap
    }
  }
};

export const configAmedasSunshineLayer = {
  ..._baseConfigLayer,
  "Attributes": {
    ..._baseConfigLayer.Attributes,
    "point": {
      ..._baseConfigLayer.Attributes.point,
      "color": sunshineColorMap
    },
    "label": {
      ..._baseConfigLayer.Attributes.label,
      "point_color": sunshineColorMap,
      "edge_color": sunshineColorMap
    },
    "popup": {
      ..._baseConfigLayer.Attributes.popup,
      "point_color": sunshineColorMap,
      "line_color": sunshineColorMap
    }
  }
};

export const configAmedasPrecipitationLayer = {
  ..._baseConfigLayer,
  "Attributes": {
    ..._baseConfigLayer.Attributes,
    "point": {
      ..._baseConfigLayer.Attributes.point,
      "color": precipitationColorMap
    },
    "label": {
      ..._baseConfigLayer.Attributes.label,
      "point_color": precipitationColorMap,
      "edge_color": precipitationColorMap
    },
    "popup": {
      ..._baseConfigLayer.Attributes.popup,
      "point_color": precipitationColorMap,
      "line_color": precipitationColorMap
    }
  }
};

export const configAmedasSnowDepthLayer = {
  ..._baseConfigLayer,
  "Attributes": {
    ..._baseConfigLayer.Attributes,
    "point": {
      ..._baseConfigLayer.Attributes.point,
      "color": snowDepthColorMap
    },
    "label": {
      ..._baseConfigLayer.Attributes.label,
      "point_color": snowDepthColorMap,
      "edge_color": snowDepthColorMap
    },
    "popup": {
      ..._baseConfigLayer.Attributes.popup,
      "point_color": snowDepthColorMap,
      "line_color": snowDepthColorMap
    }
  }
};

export const configAmedasWindDirectionLayer = {
  "Name": "GeoJSON_WND_DIR",
  "Renderer": "GeoJSONExt",
  "Attributes": {
    "features": [
      {
        "style": {
          "default": [
            {
              "type": "image",
              "width": 70,
              "height": 70,
              "offset_x": -35,
              "offset_y": -35,
              "url": {
                "property": "WNDSPDKT",
                "map": [
                  {
                  "ge": 193,
                  "lt": 198,
                  "value": "images/contents/map/amedas-color/wind-195.png"
                  },
                  {
                    "ge": 188,
                    "value": "images/contents/map/amedas-color/wind-190.png"
                  },
                  {
                    "ge": 183,
                    "value": "images/contents/map/amedas-color/wind-185.png"
                  },
                  {
                    "ge": 178,
                    "value": "images/contents/map/amedas-color/wind-180.png"
                  },
                  {
                    "ge": 173,
                    "value": "images/contents/map/amedas-color/wind-175.png"
                  },
                  {
                    "ge": 168,
                    "value": "images/contents/map/amedas-color/wind-170.png"
                  },
                  {
                    "ge": 163,
                    "value": "images/contents/map/amedas-color/wind-165.png"
                  },
                  {
                    "ge": 158,
                    "value": "images/contents/map/amedas-color/wind-160.png"
                  },
                  {
                    "ge": 153,
                    "value": "images/contents/map/amedas-color/wind-155.png"
                  },
                  {
                    "ge": 148,
                    "value": "images/contents/map/amedas-color/wind-150.png"
                  },
                  {
                    "ge": 143,
                    "value": "images/contents/map/amedas-color/wind-145.png"
                  },
                  {
                    "ge": 138,
                    "value": "images/contents/map/amedas-color/wind-140.png"
                  },
                  {
                    "ge": 133,
                    "value": "images/contents/map/amedas-color/wind-135.png"
                  },
                  {
                    "ge": 128,
                    "value": "images/contents/map/amedas-color/wind-130.png"
                  },
                  {
                    "ge": 123,
                    "value": "images/contents/map/amedas-color/wind-125.png"
                  },
                  {
                    "ge": 118,
                    "value": "images/contents/map/amedas-color/wind-120.png"
                  },
                  {
                    "ge": 113,
                    "value": "images/contents/map/amedas-color/wind-115.png"
                  },
                  {
                    "ge": 108,
                    "value": "images/contents/map/amedas-color/wind-110.png"
                  },
                  {
                    "ge": 103,
                    "value": "images/contents/map/amedas-color/wind-105.png"
                  },
                  {
                    "ge": 98,
                    "value": "images/contents/map/amedas-color/wind-100.png"
                  },
                  {
                    "ge": 93,
                    "value": "images/contents/map/amedas-color/wind-95.png"
                  },
                  {
                    "ge": 88,
                    "value": "images/contents/map/amedas-color/wind-90.png"
                  },
                  {
                    "ge": 83,
                    "value": "images/contents/map/amedas-color/wind-85.png"
                  },
                  {
                    "ge": 78,
                    "value": "images/contents/map/amedas-color/wind-80.png"
                  },
                  {
                    "ge": 73,
                    "value": "images/contents/map/amedas-color/wind-75.png"
                  },
                  {
                    "ge": 68,
                    "value": "images/contents/map/amedas-color/wind-70.png"
                  },
                  {
                    "ge": 63,
                    "value": "images/contents/map/amedas-color/wind-65.png"
                  },
                  {
                    "ge": 58,
                    "value": "images/contents/map/amedas-color/wind-60.png"
                  },
                  {
                    "ge": 53,
                    "value": "images/contents/map/amedas-color/wind-55.png"
                  },
                  {
                    "ge": 48,
                    "value": "images/contents/map/amedas-color/wind-50.png"
                  },
                  {
                    "ge": 43,
                    "value": "images/contents/map/amedas-color/wind-45.png"
                  },
                  {
                    "ge": 38,
                    "value": "images/contents/map/amedas-color/wind-40.png"
                  },
                  {
                    "ge": 33,
                    "value": "images/contents/map/amedas-color/wind-35.png"
                  },
                  {
                    "ge": 28,
                    "value": "images/contents/map/amedas-color/wind-30.png"
                  },
                  {
                    "ge": 23,
                    "value": "images/contents/map/amedas-color/wind-25.png"
                  },
                  {
                    "ge": 18,
                    "value": "images/contents/map/amedas-color/wind-20.png"
                  },
                  {
                    "ge": 13,
                    "value": "images/contents/map/amedas-color/wind-15.png"
                  },
                  {
                    "ge": 8,
                    "value": "images/contents/map/amedas-color/wind-10.png"
                  },
                  {
                    "ge": 3,
                    "value": "images/contents/map/amedas-color/wind-5.png"
                  },
                  {
                    "ge": 1,
                    "value": "images/contents/map/amedas-color/wind-0.png"
                  },
                  {
                    "ge": 0,
                    "value": "images/contents/map/amedas-color/wind-non.png"
                  }
                ]
              },
              "rotation": {
                "property": "WNDDIR"
              }
            }
          ]
        }
      }
    ]
  }
};

export const configAmedasWindSpeedLayer = {
  "Name": "GeoJSON_WND_SPD",
  "Renderer": "GeoJSONExt",
  "Attributes": {
    "features": [
      {
        "style": {
          "default": [
            {
              "type": "text",
              "key": "WNDSPDKTTEXT",
              "offset_x": 0,
              "offset_y": 15,
              "font_size": 11,
              "fill_color": "black",
              "stroke_color": "white",
              "align:": "center"
            }
          ]
        }
      }
    ]
  }
};